var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-page',{attrs:{"breadcrumbs":_vm.breadcrumbs,"container":false}},[(!_vm.loadersMap.cmsPage)?_c('layout-placeholder',{attrs:{"blocks":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }